import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import actions from './actions';
import Button from '../../../Button';
import ImportDropzone from '../../../ImportDropzone';
import ImportFileList from './ImportFileList';
import Loader from '../../../Loader';
import styles from './ImportSection.module.scss';

function ImportFileArea(props) {
  return (
    props.acceptedFiles && props.acceptedFiles.length > 0 ?
    <>
      <ImportFileList files={props.acceptedFiles} />
      <div className={styles.importButtons}>
        <Button onClick={props.clearImport} theme={Button.THEME.outlinePrimary} size={Button.SIZE.small}>Cancel</Button>
        <Button onClick={props.saveImport} theme={Button.THEME.orange} size={Button.SIZE.small}>Upload</Button>
      </div>
    </> : 
    <ImportDropzone />
  );
}

ImportFileArea.propTypes = {
  acceptedFiles: PropTypes.array,
  clearImport: PropTypes.func,
  saveImport: PropTypes.func
};

function ImportSection(props) {
  return (
    <div className={styles.container}>
      <h2 className={styles.sectionHeader}>Import your map items</h2>
      <p className={styles.description}>Add waypoints, tracks, and other data from your GPS or other mapping platforms.</p>
      { props.isImportingContent ?
        <div className={styles.importLoader}>
          <Loader active={true} />Importing file...
        </div> :
        <ImportFileArea
          acceptedFiles={props.acceptedFiles}
          clearImport={props.clearImport}
          saveImport={props.saveImport}
        />
      }
    </div>
  );
}

ImportSection.propTypes = {
  acceptedFiles: PropTypes.array,
  importedFeatures: PropTypes.array,
  importError: PropTypes.string,
  isImportingContent: PropTypes.bool,
  //actions
  clearImport: PropTypes.func,
  saveImport: PropTypes.func,
};

export default connect((model) => ({
  acceptedFiles: model.dataManager.acceptedFiles,
  importedFeatures: model.dataManager.importedFeatures,
  importError: model.dataManager.importError,
  isImportingContent: model.dataManager.isImporting,
}), actions)(ImportSection);